import m from "../../geodata/es2015/thailandHigh";
window.am4geodata_thailandHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/thailandHigh.js
// module id = null
// module chunks = 